import { render } from "./Wz1Details.vue?vue&type=template&id=0ebc6ddb&scoped=true"
import script from "./Wz1Details.vue?vue&type=script&lang=js"
export * from "./Wz1Details.vue?vue&type=script&lang=js"

import "./Wz1Details.vue?vue&type=style&index=0&id=0ebc6ddb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebc6ddb"]])

export default __exports__